var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"success"},[_c('fail-animation'),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"payment-suc"},[_c('p',{attrs:{"dir":"rtl"}},[_vm._v("עסקה בוטלה")])])
}]

export { render, staticRenderFns }